/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';
import SettlementControllerDtoDoSettlementRequiredTransaction from './SettlementControllerDtoDoSettlementRequiredTransaction';

/**
 * The SettlementControllerDtoDoSettlementResponse model module.
 * @module model/SettlementControllerDtoDoSettlementResponse
 * @version 1.0
 */
class SettlementControllerDtoDoSettlementResponse {
    /**
     * Constructs a new <code>SettlementControllerDtoDoSettlementResponse</code>.
     * @alias module:model/SettlementControllerDtoDoSettlementResponse
     */
    constructor() { 
        
        SettlementControllerDtoDoSettlementResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SettlementControllerDtoDoSettlementResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SettlementControllerDtoDoSettlementResponse} obj Optional instance to populate.
     * @return {module:model/SettlementControllerDtoDoSettlementResponse} The populated <code>SettlementControllerDtoDoSettlementResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SettlementControllerDtoDoSettlementResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('requiredTransaction')) {
                obj['requiredTransaction'] = SettlementControllerDtoDoSettlementRequiredTransaction.constructFromObject(data['requiredTransaction']);
            }
            if (data.hasOwnProperty('destinationWalletAddr')) {
                obj['destinationWalletAddr'] = ApiClient.convertToType(data['destinationWalletAddr'], {'String': 'String'});
            }
            if (data.hasOwnProperty('requestedSettlementIds')) {
                obj['requestedSettlementIds'] = ApiClient.convertToType(data['requestedSettlementIds'], ['String']);
            }
            if (data.hasOwnProperty('committedSettlementIds')) {
                obj['committedSettlementIds'] = ApiClient.convertToType(data['committedSettlementIds'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SettlementControllerDtoDoSettlementResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SettlementControllerDtoDoSettlementResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // validate the optional field `requiredTransaction`
        if (data['requiredTransaction']) { // data not null
          SettlementControllerDtoDoSettlementRequiredTransaction.validateJSON(data['requiredTransaction']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['requestedSettlementIds'])) {
            throw new Error("Expected the field `requestedSettlementIds` to be an array in the JSON data but got " + data['requestedSettlementIds']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['committedSettlementIds'])) {
            throw new Error("Expected the field `committedSettlementIds` to be an array in the JSON data but got " + data['committedSettlementIds']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
SettlementControllerDtoDoSettlementResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
SettlementControllerDtoDoSettlementResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
SettlementControllerDtoDoSettlementResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
SettlementControllerDtoDoSettlementResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
SettlementControllerDtoDoSettlementResponse.prototype['contentsReward'] = undefined;

/**
 * @member {module:model/SettlementControllerDtoDoSettlementRequiredTransaction} requiredTransaction
 */
SettlementControllerDtoDoSettlementResponse.prototype['requiredTransaction'] = undefined;

/**
 * @member {Object.<String, String>} destinationWalletAddr
 */
SettlementControllerDtoDoSettlementResponse.prototype['destinationWalletAddr'] = undefined;

/**
 * @member {Array.<String>} requestedSettlementIds
 */
SettlementControllerDtoDoSettlementResponse.prototype['requestedSettlementIds'] = undefined;

/**
 * @member {Array.<String>} committedSettlementIds
 */
SettlementControllerDtoDoSettlementResponse.prototype['committedSettlementIds'] = undefined;






export default SettlementControllerDtoDoSettlementResponse;

